import { Ref, UnwrapNestedRefs } from 'vue'
import { FormItemReference } from './interface'
import { ValidateTiming, FormSize, Direction } from '../../enums'

export const formProvision = Symbol('d-form')
export const formItemProvision = Symbol('d-form-item')

export interface FormProvision {
  modelValue: UnwrapNestedRefs<Record<string, any>>
  validateTiming: Ref<ValidateTiming>
  size: Ref<FormSize>
  direction: Ref<Direction>
  formItems: UnwrapNestedRefs<Record<string, FormItemReference>>
}

export interface FormItemProvision {
  modelValue: Ref<any>
  validateTiming: Ref<ValidateTiming>
  register: (v: FormItemReference) => any
  unregister: (v: FormItemReference) => void
}
